// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`CanvasListCourses renders the list of Canvas courses 1`] = `
<DocumentFragment>
  .emotion-0 {
  display: table;
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.emotion-0 caption {
  padding: 16px;
  color: #1C1B1FB3;
  text-align: left;
  caption-side: bottom;
}

.emotion-1 {
  display: table-header-group;
  background-color: #FCFAFD;
}

.emotion-2 {
  color: inherit;
  display: table-row;
  vertical-align: middle;
  outline: 0;
}

.emotion-2.MuiTableRow-hover:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.emotion-2.Mui-selected {
  background-color: rgba(75, 53, 255, 0.08);
}

.emotion-2.Mui-selected:hover {
  background-color: rgba(75, 53, 255, 0.12);
}

.emotion-3 {
  display: table-cell;
  vertical-align: inherit;
  border-bottom: 1px solid rgba(250, 249, 250, 1);
  text-align: left;
  padding: 16px;
  color: #1C1B1F;
  line-height: 1.5rem;
  font-weight: 500;
  border-bottom-color: #D6D5DD;
  padding: 8px 16px;
  height: 56px;
  padding: 12px 16px;
  height: auto;
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
}

.emotion-5 {
  display: table-row-group;
}

.emotion-7 {
  display: table-cell;
  vertical-align: inherit;
  border-bottom: 1px solid rgba(250, 249, 250, 1);
  text-align: left;
  padding: 16px;
  color: #1C1B1F;
  border-bottom-color: #D6D5DD;
  padding: 8px 16px;
  height: 56px;
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.emotion-8 {
  margin: 0;
  font: inherit;
  color: #4B35FF;
  -webkit-text-decoration: none;
  text-decoration: none;
  color: #4B35FF;
}

.emotion-8:hover {
  -webkit-text-decoration: underline;
  text-decoration: underline;
}

<table
    class="MuiTable-root emotion-0"
  >
    <thead
      class="MuiTableHead-root emotion-1"
    >
      <tr
        class="MuiTableRow-root MuiTableRow-head emotion-2"
      >
        <th
          class="MuiTableCell-root MuiTableCell-head MuiTableCell-sizeMedium emotion-3"
          scope="col"
        >
          Course Name
        </th>
        <th
          class="MuiTableCell-root MuiTableCell-head MuiTableCell-sizeMedium emotion-3"
          scope="col"
        >
          Course Code
        </th>
      </tr>
    </thead>
    <tbody
      class="MuiTableBody-root emotion-5"
    >
      <tr
        class="MuiTableRow-root emotion-2"
      >
        <td
          class="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeMedium emotion-7"
        >
          <a
            class="MuiTypography-root MuiTypography-inherit MuiLink-root MuiLink-underlineHover emotion-8"
            data-testid="course-create-link-1"
            to="/studio/canvas/courses/1"
          >
            Course 1
          </a>
        </td>
        <td
          class="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeMedium emotion-7"
        >
          C1
        </td>
      </tr>
      <tr
        class="MuiTableRow-root emotion-2"
      >
        <td
          class="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeMedium emotion-7"
        >
          <a
            class="MuiTypography-root MuiTypography-inherit MuiLink-root MuiLink-underlineHover emotion-8"
            data-testid="course-create-link-2"
            to="/studio/canvas/courses/2"
          >
            Course 2
          </a>
        </td>
        <td
          class="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeMedium emotion-7"
        >
          C2
        </td>
      </tr>
    </tbody>
  </table>
</DocumentFragment>
`;
